export function SportBetaBadge({ emphasised = false }: { emphasised?: boolean }) {
  return (
    <span
      data-beta-emphasised={emphasised || undefined}
      className={`inline-flex min-h-5 items-center rounded-full px-2 text-[11px] font-bold text-navy ${
        emphasised ? "bg-gold" : "bg-gold/15"
      }`}
    >
      Beta
    </span>
  );
}
